import { Zap, Wind, Monitor, Maximize2, Package, Wifi, Users, Shield, Coffee, Droplets, Toilet } from "lucide-react";
import busImage from "@/assets/Additional-Images/Additional1.jpeg";

export function BusAmenitiesSection() {
  const amenities = [
    {
      icon: Zap,
      title: "USB Charging",
      description: "Keep your devices powered throughout your journey"
    },
    {
      icon: Wind,
      title: "Air Conditioning",
      description: "Comfortable climate control for every ride"
    },
    {
      icon: Monitor,
      title: "Entertainment",
      description: "In-seat entertainment systems for your enjoyment"
    },
    {
      icon: Maximize2,
      title: "Extra Legroom",
      description: "Spacious seating for maximum comfort"
    },
    {
      icon: Package,
      title: "Overhead Storage",
      description: "Secure storage for your luggage and bags"
    },
    {
      icon: Wifi,
      title: "WiFi Available",
      description: "Stay connected with internet access"
    },
    {
      icon: Coffee,
      title: "Complimentary Snacks",
      description: "Complimentary snacks served onboard"
    },
    {
      icon: Toilet,
      title: "Restrooms Onboard",
      description: "Modern restroom facilities available"
    },
    {
      icon: Users,
      title: "Professional Staff",
      description: "Courteous and trained crew members"
    },
    {
      icon: Shield,
      title: "Safety First",
      description: "Modern safety equipment and protocols"
    }
  ];

  return (
    <section className="section-padding bg-background relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in-up">
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-6">
            Bus <span className="text-gradient">Amenities</span>
          </h2>
          <p className="text-xl text-muted-foreground">
            Travel in comfort with our premium features
          </p>
        </div>

        {/* Amenities Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 max-w-7xl mx-auto">
          {amenities.map((amenity, index) => {
            const IconComponent = amenity.icon;
            return (
              <div
                key={index}
                className="group relative p-6 rounded-2xl bg-card/50 border border-border/50 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon Container */}
                <div className="mb-4 inline-flex">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 group-hover:bg-primary group-hover:neon-glow flex items-center justify-center transition-all duration-300">
                    <IconComponent className="w-6 h-6 text-primary group-hover:text-primary-foreground transition-colors" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="font-display font-semibold text-lg mb-2 text-foreground">
                  {amenity.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {amenity.description}
                </p>

                {/* Accent line */}
                <div className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-primary to-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-0 group-hover:w-full rounded-b-2xl" />
              </div>
            );
          })}
        </div>

        {/* Bus Image Section */}
        <div className="mt-16 max-w-4xl mx-auto animate-fade-in-up animation-delay-200">
          <div className="relative rounded-3xl overflow-hidden border-2 border-primary/20 group cursor-pointer">
            <img
              src={busImage}
              alt="Luxury Bus Interior"
              className="w-full h-96 object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
        </div>
      </div>
    </section>
  );
}
